// extracted by mini-css-extract-plugin
export default {"roles":"_28LxM-bo","chips":"ya0PbCl2","chip":"_2UzO11RX","moreChip":"fBs5dmrx","addChip":"_1c-ctWHY","editWrp":"_3YL587Bz","editModal":"_1qalom22"};